import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import HomePage from '../views/HomePage.vue'
import UserManagement from '../views/user/UserManagement.vue'
import AccountManagement from '../views/account/AccountManagement.vue'
import AddressManagement from '../views/address/AddressManagement.vue'
import ActivityManagement from '../views/activity/ActivityManagement.vue'
import ExpressManagement from '../views/express/ExpressManagement.vue'
import AuctionManagement from '../views/auction/AuctionManagement.vue'
import RemittanceOrderManagement from '../views/remittance/RemittanceOrderManagement.vue'
import WithdrawRecordManagement from '../views/withdraw/WithdrawRecordManagement.vue'
import RoleManagement from '../views/role/RoleManagement.vue'
import MenuManagement from '../views/menu/MenuManagement.vue'
import CardRecommendation from '../views/card/CardRecommendation.vue'
import CouponManagement from '../views/coupon/CouponManagement.vue'
import CouponIssueManagement from '../views/coupon/CouponIssueManagement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
    redirect: '/',
    children: [
      {
        path: '',
        name: 'HomePage',
        component: HomePage,
        meta: { requiresAuth: true }
      },
      {
        path: 'user',
        name: 'UserManagement',
        component: UserManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'account',
        name: 'AccountManagement',
        component: AccountManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'address',
        name: 'AddressManagement',
        component: AddressManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'activity',
        name: 'ActivityManagement',
        component: ActivityManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'express',
        name: 'ExpressManagement',
        component: ExpressManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'auction',
        name: 'AuctionManagement',
        component: AuctionManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'remittance',
        name: 'RemittanceOrderManagement',
        component: RemittanceOrderManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'withdraw',
        name: 'WithdrawRecordManagement',
        component: WithdrawRecordManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'role',
        name: 'RoleManagement',
        component: RoleManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'menu',
        name: 'MenuManagement',
        component: MenuManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'card',
        name: 'CardRecommendation',
        component: CardRecommendation,
        meta: { requiresAuth: true }
      },
      {
        // 以 / 开头即为绝对路径，不会被父级 path 拼接；保持在 Home children 中以保留侧边栏布局
        path: '/coupon',
        name: 'CouponManagement',
        component: CouponManagement,
        meta: { requiresAuth: true }
      },
      {
        path: '/coupon/issue',
        name: 'CouponIssueManagement',
        component: CouponIssueManagement,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
  } else if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
